import request from "@/utils/request";

// 课程列表
export function getCourses(params) {
  return request({
    url: `/client/course/getList`,
    method: "get",
    params: params,
  });
}

// 课程详情
export function getCourseDetial(courseId) {
  return request({
    url: `/client/course/getDetail?courseId=${courseId}`,
    method: "get",
  });
}

// 获课程列表页面的banner列表
export function getCourseBannerList() {
  return request({
    url: `/client/course/getBannerList`,
    method: "get",
  });
}

// 获课程列表页面的banner列表
export function getCooperationList() {
  return request({
    url: `/client/course/getCooperationList`,
    method: "get",
  });
}

export function getCourseWorkInfo(courseId) {
  return request({
    url: `/client/courseWork/getCourseWorkInfo?courseId=${courseId}`,
    method: "get",
  });
}

export function saveCourseWorkInfo(data) {
  return request({
    url: `/client/courseWork/commit`,
    method: "post",
    data,
  });
}

export function videoPlayStart(data) {
  return request({
    url: `/client/course/playCallback/onPlay`,
    method: "post",
    data,
  });
}
export function videoPlayEnd(data) {
  return request({
    url: `/client/course/playCallback/onEnded`,
    method: "post",
    data,
  });
}

export function certificateCheck(number) {
  return request({
    url: `/client/courseCertificate/check?number=${number}`,
    method: "get",
  });
}


export function getStudyProgress(courseId) {
  return request({
    url: `/client/courseStudyProgress/getDetail?courseId=${courseId}`,
    method: "get",
  });
}

export function commitExpressAddress(data) {
  return request({
    url: `/client/courseCertificateExpressAddress/commit`,
    method: "post",
    data,
  });
}